<template>
  <div class="container">
    <div class="avatar"><img src="../../assets/img/global/avatar.png"></div>
    <div class="title">{{userInfo.name}}</div>
    <div class="vip"><img src="../../assets/img/user/vip.png"></div>

    <div class="round-container">
      <div class="weui-cells" >
        <div class="weui-cell" v-show="userInfo.phone">
            <div class="weui-cell__bd">
                <p>手机号</p>
            </div>
            <div class="weui-cell__ft">{{ userInfo.phone}}</div>
        </div>
        <div class="weui-cell" v-show="userInfo.email">
            <div class="weui-cell__bd">
                <p>Email</p>
            </div>
            <div class="weui-cell__ft">{{ userInfo.email}}</div>
        </div>
        
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="goto('/reset-password')">
            <div class="weui-cell__bd">
                <p>密码</p>
            </div>
            <div class="weui-cell__ft">点击修改密码</div>
        </a>

      </div>
    </div>


    <div class="round-container">
      <div class="weui-cells" >
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="goto('/order')">
            <div class="weui-cell__bd">
                <p>我的订单</p>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="goto('/coupon-list')">
            <div class="weui-cell__bd">
                <p>我的优惠券</p>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
      </div>
    </div>


    <div class="round-container">
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" >
            <div class="weui-cell__bd">
               <router-link to="/terms-and-conditions?back=1"><p>服务条款</p></router-link>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" >
            <div class="weui-cell__bd">
               <router-link to="/refund-policy?back=1"><p>退款条款</p></router-link>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="https://www.daojia.com.au/about/contact.html" target="_blank">
            <div class="weui-cell__bd">
               <p>联系我们</p>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" >
            <div class="weui-cell__bd">
                <a href="//about.daojia.com.au" target="_blank">
                  <p>关于我们</p>
                </a>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
      </div>
    </div>

    <div class="btn-box">
      <div class="btn white active" @click="logout()">登出账号</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'profile',
  data () {
    return {
      userInfo:{
        phone:'',
        email:'',
        name:'',        
      }
    }
  },
  methods: {
    logout(){
      let result = window.confirm("确定要登出账号吗？");
      if(result){
        this.clearLoginLS();
        this.$router.push('/');
      }
    },  
  },
  components: {
  },
  mounted: function () {
    if (localStorage.member_phone || localStorage.member_email) {
      this.userInfo.phone = localStorage.member_phone;
      this.userInfo.email = localStorage.member_email;
      this.userInfo.name = localStorage.member_name;
    }
    else{
      this.profileValidate();
    }
    document.querySelector("html").classList.add("profile-bg");
  },
  destroyed() {
    document.querySelector("html").classList.remove("profile-bg");
  },
  created() {
    if(!this.checkLogin()){
      this.$router.push('/profile-login');
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.avatar{
  text-align:center;
  margin-top:30px;
  font-size:0;
  img{
    background:#fff;
    border-radius:50%;
    padding:10px;
    width:44px;
  }
}
.btn{
  margin-top:20px;
}
.title{
  font-size:1.6em;
  color:#fff;
  padding-bottom:0;
}
.vip{
  text-align:center;
  margin-bottom:20px;
  img{
    width:60px;
  }
}
.round-container{
  padding: 0 16px 20px 16px;
  .weui-cells{
    margin-top:4px;
    border-radius:8px;
    -webkit-box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.7);
    box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.7);
  }
  .weui-cells:after, .weui-cells:before{
    border:0;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/profile.vue